import {Component, OnInit} from '@angular/core';
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "app/login/login.service";
import {ProtestosFichasModel} from "./protestos-fichas.model";
import {ProtestosFichasService} from "./protestos-fichas.service";

declare let swal: any;

@Component({
  selector: 'app-protestos-fichas',
  templateUrl: './protestos-fichas.component.html'
})
export class ProtestosFichasComponent extends Components implements OnInit {

  protestos: ProtestosFichasModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    private protestosFichasService: ProtestosFichasService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'fichas'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.getPage(1);
  }

  delete(protesto) {
    let protestos = this.protestos;
    let protestosFichasService = this.protestosFichasService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarProtesto')+protesto.protesto_pt,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(protestos);
        }

        let index = protestos.indexOf(protesto);
        protestos.splice(index, 1);

        protestosFichasService.apagar(protesto.id_protesto)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              self.protestos = protestos;
            },
            err => {
              // Revert the view back to its original state
              protestos.splice(index, 0, protesto);
              self.protestos = protestos;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.protestosFichasService.getPaginacao(pagina,this.itensPorPagina)
      .subscribe(data => {
        this.protestos = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/protestos-fichas/protestos-fichas.component.ts